import React, { useState, useEffect } from "react";
import axios from "axios";
import Title from "../components/Title";
import styled from "styled-components";
import BookList from "../components/BookList";
import Button from "../components/Button";

function MainBookShelf({ history }) {
  const baseUrl = "http://54.180.26.235:8000";

  useEffect(() => {
    getBooks();
  }, []); //빈 배열 줌으로서 시작시 한번만 실행하게 함

  async function getBooks() {
    axios
      .get(baseUrl + "/books")
      .then((response) => {
        console.log(response.data.RESULT);
        setBooks(response.data.RESULT);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  //뷰에 보일 book 구성할 state 변수
  const [books, setBooks] = useState([]);

  const gotoCreate = () => {
    history.push("/createbook");
  };
  return (
    <MainBookShelfWrap>
      <div className="container">
        <Title className="title" />
        <BookListContainer>
          {books &&
            books.map((book, index) => <BookList book={book} key={index} />)}
        </BookListContainer>
        <Button
          onClick={gotoCreate}
          className="btn-create"
          size="large"
          color="brwn"
        >
          책 추가
        </Button>
      </div>
    </MainBookShelfWrap>
  );
}

export default MainBookShelf;

const BookListContainer = styled.div`
  margin-top: 20px;
  margin-left: 56px;
  height: 421px;
  width: 598px;
  overflow-y: scroll;
`;

const MainBookShelfWrap = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .container {
    width: 710px;
    height: 777px;
    background: #fdf0bc;
    box-shadow: 0px 6px 13px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
  }
  .title {
    margin-top: 94px;
    margin-left: 66px;
  }
  .btn-create {
    margin-left: 500px;
    margin-top: 40px;
  }
`;
